// WP-2.8 (CA-6, OB-1, S-39..46 "AI"): the budget meter + activity-log viewer query.
import { aiUsageResponseSchema, type AiUsageResponse } from '@pfos/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from './api';

export const AI_USAGE_KEY = ['ai-usage'] as const;

export function useAiUsage(): UseQueryResult<AiUsageResponse> {
  return useQuery({
    queryKey: AI_USAGE_KEY,
    queryFn: async () => aiUsageResponseSchema.parse(await api.get('/api/v1/ai-usage')),
  });
}
